import React from 'react'

export default function RaceFacts({ competition, raceinfo, management }) {
  if (!competition) {
    return (
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 text-center">
        <p className="text-gray-700">Loading race facts...</p>
      </div>
    )
  }

  const DataRow = ({ label, value }) => (
    <div className="grid grid-cols-12 gap-4 py-3 border-b border-gray-200 last:border-b-0">
      <div className="col-span-4 text-right">
        <label className="font-semibold text-gray-700">{label}:</label>
      </div>
      <div className="col-span-8 text-gray-900">
        {value}
      </div>
    </div>
  )

  return (
    <div className="space-y-6">
      {/* Hill Information */}
      <div className="bg-white rounded-lg p-6 shadow-sm">
        <h3 className="text-lg font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">
          Hill Information
        </h3>
        
        <DataRow label="Hill name" value={competition.hill?.name || 'N/A'} />
        
        {competition.hill?.hill_jumpers && competition.hill.hill_jumpers.length > 0 && (
          <DataRow 
            label="Record holder" 
            value={
              <div className="space-y-2">
                {competition.hill.hill_jumpers.map((hj, idx) => (
                  <div key={idx} className="text-sm">
                    <span className="font-bold">{hj.distance}m</span> - {hj.jumper.name} ({hj.jumper.nation.shortname}) - {hj.record_date}
                  </div>
                ))}
              </div>
            } 
          />
        )}
        
        <DataRow label="Hill Size (HS)" value={`${competition.hill?.hill_size || 'N/A'}m`} />
        <DataRow label="K-Point" value={`${competition.hill?.point_k || 'N/A'}m`} />
        <DataRow label="Meter Value" value={raceinfo?.mvalue || 'N/A'} />
        <DataRow label="Gate factor" value={`${competition.hill?.gate_factor || 'N/A'} pts per m`} />
        <DataRow label="Headwind factor" value={`${competition.hill?.headwind_factor || 'N/A'} pts per m/s`} />
        <DataRow label="Backwind factor" value={`${competition.hill?.backwind_factor || 'N/A'} pts per m/s`} />
      </div>

      {/* Officials and Judges */}
      {management && (
        <>
          {/* Competition Management */}
          {management.competition_management && management.competition_management.length > 0 && (
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-lg font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">
                Competition Management
              </h3>
              <ul className="space-y-3">
                {management.competition_management.map((row, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <img
                      src={row.photo || '/images/hill.png'}
                      width="48"
                      className="rounded"
                      alt={row.name}
                      onError={(e) => { e.target.src = '/images/hill.png' }}
                    />
                    <span className="text-gray-900">
                      <span className="font-semibold">{row.function}:</span> {row.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Jury */}
          {management.jury && management.jury.length > 0 && (
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-lg font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">
                Jury
              </h3>
              <ul className="space-y-3">
                {management.jury.map((row, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <img
                      src={row.photo || '/images/hill.png'}
                      width="48"
                      className="rounded"
                      alt={row.name}
                      onError={(e) => { e.target.src = '/images/hill.png' }}
                    />
                    <span className="text-gray-900">
                      <span className="font-semibold">{row.function}:</span> {row.name}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Judges */}
          {management.judges && management.judges.length > 0 && (
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="text-lg font-bold text-gray-900 mb-4 border-b border-gray-200 pb-2">
                Judges
              </h3>
              <ul className="space-y-3">
                {management.judges.map((row, idx) => (
                  <li key={idx} className="flex items-center gap-3">
                    <img
                      src={row.photo || '/images/hill.png'}
                      width="48"
                      className="rounded"
                      alt={row.name}
                      onError={(e) => { e.target.src = '/images/hill.png' }}
                    />
                    <span className="text-gray-900">
                      {row.name} ({row.nation})
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </div>
  )
}
